import { relation } from "../config/oqic";

/**
 * Generates an array of person objects with dynamic birthDates.
 * @param {Array<{count: number, age: number}>} groups
 * @returns {Array<{ person: { birthDate: string, gender: { code: string, value: string } } }>}
 */
export const createPeopleArrayFromGroups = (groups) => {
  return groups.flatMap(({ count, age }) => {
    const birthDate = new Date();
    birthDate.setFullYear(birthDate.getFullYear() - age);
    const formattedDate = birthDate.toISOString().split("T")[0];

    return Array.from({ length: count }, () => ({
      person: {
        birthDate: formattedDate,
        gender: {
          code: "M",
          value: "Male",
        },
      },
    }));
  });
};

export const prepareGigInsuranceCardData = (companyList, travelProductType) => {
  let data = [];
  if (companyList && companyList.length) {
    companyList.forEach((company) => {
      console.log("GIG company", company);
      let travel_product_type =
        travelProductType && travelProductType.length
          ? travelProductType[0]?.options
          : [];
      let plans;
      if (company?.product_id === 1) {
        //for Motor Product
        plans =
          company?.extracted_data?.eligiblePlans &&
          company?.product_id === 1 &&
          company?.sub_product_id === 1
            ? company?.extracted_data?.eligiblePlans?.filter(
                (plan) =>
                  plan?.uwApprovalStatus === "Y" &&
                  plan?.product?.code !== "VA11" &&
                  plan?.product?.code !== "VA19"
              )
            : company?.extracted_data?.eligiblePlans?.filter(
                (plan) =>
                  plan?.uwApprovalStatus === "Y" &&
                  (plan?.product?.code === "VA11" ||
                    plan?.product?.code === "VA19")
              ) || [];
      } else {
        //for Travel Product & other products
        plans =
          company?.extracted_data?.eligiblePlans &&
          company?.extracted_data?.eligiblePlans?.length
            ? company?.extracted_data?.eligiblePlans?.filter(
                (plan) =>
                  plan?.uwApprovalStatus === "Y" &&
                  plan?.product?.code !== "ZT15"
              )
            : [];
      }
      // console.log("GIG plans", plans);

      if (plans && plans.length) {
        plans.forEach((plan, index) => {
          data.push({
            product_id: company?.product_id,
            sub_product_id: company?.sub_product_id,
            object_id: index,
            company_name: company?.insurance_company?.company_title,
            company_name_ar: company?.insurance_company?.company_title_ar,
            company_description_en:
              company?.insurance_company?.company_descriptions_en,
            company_description_ar:
              company?.insurance_company?.company_descriptions_ar,
            company_faq_en: company?.insurance_company?.faq_en,
            company_faq_ar: company?.insurance_company?.faq_ar,
            company_id: company?.insurance_company?.id,
            company_image: company?.insurance_company?.image,
            plan_code: plan?.product?.code,
            plan_name: plan?.product?.value,
            base_price: plan?.premium?.grossPremium?.amount,
            premium_value: plan?.premium?.grossPremium?.amount,
            premium_currency: plan?.premium?.grossPremium?.currencyCode,
            included_covers:
              plan?.covers && plan?.covers?.length
                ? plan?.covers?.filter((cover) => cover?.isSelected === true)
                : [],
            optional_covers:
              plan?.covers && plan?.covers?.length
                ? plan?.covers?.filter((cover) => cover?.isSelected === false)
                : [],
            extracted_data: company?.extracted_data || {},
            insurance_company_product_mapping_id: company?.id,
            area_of_coverage:
              travel_product_type.find(
                (tp) => tp.company == company?.insurance_company?.id
              ) || null,
          });
        });
      }
    });
  }

  return data;
};

export function transformToInsuredMembers(data) {
  return {
    insuredMembers: data.map((entry) => {
      const { surName, givenName, birthDate, gender,relationship } = entry.person;
      return {
        person: {
          surName,
          givenName,
          birthDate,
          gender,
          relationship,
          otherRelationshipDescription: "string",
          nationality: {
            code: "IND",
            value: "India",
          },
        },
      };
    }),
  };
}

export function transformToInsuredMembersForPutQuote(data) {
  return {
    insuredMembersPut: data.map((entry) => {
      const { surName, givenName, birthDate, gender, relationship } = entry.person;
      return {
        person: {
          surName,
          givenName,
          birthDate,
          gender,
          relationship,
          otherRelationshipDescription: "string",
          nationality: {
            code: "IND",
            value: "India",
          },
        },
      };
    }),
  };
}

export const convertToISOWithPlus365 = (dateStr) => {
  const originalDate = new Date(dateStr);

  // Add 365 days
  const futureDate = new Date(originalDate);
  futureDate.setDate(futureDate.getDate() + 365);

  // Subtract 1 day to get one day before
  futureDate.setDate(futureDate.getDate() - 1);

  return {
    originalISO: originalDate.toISOString(),
    plus365ISO: futureDate.toISOString(),
  };
};

export const getYearDifferenceFromToday = (dateString) => {
  // Convert input string to Date object
  const year = parseInt(dateString?.slice(0, 4), 10);
  const month = parseInt(dateString?.slice(4, 6), 10) - 1; // JS months are 0-based
  const day = parseInt(dateString?.slice(6, 8), 10);
  const inputDate = new Date(year, month, day);

  const today = new Date();

  let yearDiff = today.getFullYear() - inputDate.getFullYear();

  // Adjust if the current date is before the input date's month/day
  const hasNotHadBirthdayThisYear =
    today.getMonth() < inputDate.getMonth() ||
    (today.getMonth() === inputDate.getMonth() &&
      today.getDate() < inputDate.getDate());

  if (hasNotHadBirthdayThisYear) {
    yearDiff--;
  }

  return yearDiff;
};

//temprary function to get generate chasis number
export const generateUniqueStringWithTime = (length = 13) => {
  const base = generateUniqueString(length);
  const timestamp = Date.now().toString(16).slice(-4).toUpperCase();
  return base + timestamp;
};

export const generateUniqueString = (length = 17) => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

export const buildMotorInfoListGig = (rop) => {
  const vehicleInfo =
    rop?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.VehicleInfo;

  const licenseInfo =
    rop?.ropLicense?.Body?.GetLicenseInfoResponse
      ?.GetLicenseInfoResult;

  return {
    motorInfoList: [
      // 1️⃣ GetVehicleInfoByChassis
      {
        operation: "GetVehicleInfoByChassis",
        request: {
          namespace: "http://Ingenuity.net/eInsuranceWS//UploadService",
          method: "GetVehicleInfoByChassis",
          params: {
            ChassisNo: vehicleInfo?.ChassisNumber ?? "",
            Language: "Eng"
          }
        },
        response: {
          VehicleBarcode: vehicleInfo?.VehicleBarcode,
          RegistraionType: vehicleInfo?.RegistraionType,
          RegistraionTypeDesc: vehicleInfo?.RegistraionTypeDesc,
          PlateCode: vehicleInfo?.PlateCode,
          PlateCodeArb: vehicleInfo?.PlateCodeArb,
          PlateNumber: vehicleInfo?.PlateNumber,
          ChassisNumber: vehicleInfo?.ChassisNumber,
          EngineNumber: vehicleInfo?.EngineNumber,
          Language: "Eng",
          MakeYear: vehicleInfo?.MakeYear,
          VehicleTypeID: vehicleInfo?.VehicleTypeID,
          VehicleTypeDesc: vehicleInfo?.VehicleTypeDesc,
          VehicleMakeID: vehicleInfo?.VehicleMakeID,
          VehicleMakeDesc: vehicleInfo?.VehicleMakeDesc,
          VehicleModelID: vehicleInfo?.VehicleModelID,
          VehicleModelDesc: vehicleInfo?.VehicleModelDesc,
          ColorDesc: vehicleInfo?.ColorDesc,
          RegistrationIssueDate: vehicleInfo?.RegistrationIssueDate,
          RegistrationEndDate: vehicleInfo?.RegistrationEndDate,
          InsuranceTypeID: vehicleInfo?.InsuranceTypeID,
          InsuranceTypeDesc: vehicleInfo?.InsuranceTypeDesc,
          InsuranceStartDate: vehicleInfo?.InsuranceStartDate,
          InsuranceEndDate: vehicleInfo?.InsuranceEndDate,
          InsuranecCompanyCR: vehicleInfo?.InsuranecCompanyCR,
          InsuranceCompanyName: vehicleInfo?.InsuranceCompanyName,
          errorCode: vehicleInfo?.errorCode,
          errorText: vehicleInfo?.errorText,
          StatusCode: vehicleInfo?.StatusCode,
          StatusText: vehicleInfo?.StatusText
        }
      },

      // 2️⃣ ClaimInfoByChassis (static empty)
      {
        operation: "ClaimInfoByChassis",
        request: {
          namespace: "http://Ingenuity.net/eInsuranceWS//ClaimInfoService",
          method: "ClaimInfoByChassis",
          params: {
            sChassisNO: vehicleInfo?.ChassisNumber ?? ""
          }
        },
        response: {
          claims: []
        }
      },

      // 3️⃣ ClaimInfoByLicenseNo
      {
        operation: "ClaimInfoByLicenseNo",
        request: {
          namespace: "http://Ingenuity.net/eInsuranceWS//ClaimInfoService",
          method: "ClaimInfoByLicenseNo",
          params: {
            iLicenseNo: licenseInfo?.LicenseNumber ?? "",
            sLanguage: "Eng"
          }
        },
        response: {
          claims: []
        }
      },

      // 4️⃣ GetLicenseInfo
      {
        operation: "GetLicenseInfo",
        request: {
          namespace: "http://Ingenuity.net/eInsuranceWS//UploadService",
          method: "GetLicenseInfo",
          params: {
            LicenseNumber: licenseInfo?.LicenseNumber ?? "",
            Language: "Eng"
          }
        },
        response: {
          LicenseNumber: licenseInfo?.LicenseNumber,
          Language: "Eng",
          DateFirstIssued: licenseInfo?.DateFirstIssued,
          PlaceOfIssue: licenseInfo?.PlaceOfIssue,
          DateofExpiry: licenseInfo?.DateofExpiry,
          DateofBirth: licenseInfo?.DateofBirth,
          LicenseClass: Array.isArray(licenseInfo?.LicenseClass?.string)
            ? licenseInfo.LicenseClass.string
            : [licenseInfo?.LicenseClass?.string].filter(Boolean),
          LicenseSubclass: Array.isArray(licenseInfo?.LicenseSubclass?.string)
            ? licenseInfo.LicenseSubclass.string
            : [licenseInfo?.LicenseSubclass?.string].filter(Boolean),
          LicenseSuspendedCurrent: null,
          LicenseSuspendedPrevious: null,
          LicenseSuspendedDateEnd: licenseInfo?.LicenseSuspendedDateEnd,
          ErrorCode: licenseInfo?.ErrorCode,
          ErrorText: licenseInfo?.ErrorText,
          StatusCode: licenseInfo?.StatusCode,
          StatusText: licenseInfo?.StatusText
        }
      },

      // 5️⃣ GetVehicleInfoByPlateNo
      {
        operation: "GetVehicleInfoByPlateNo",
        request: {
          namespace: "http://Ingenuity.net/eInsuranceWS//UploadService",
          method: "GetVehicleInfoByPlate",
          params: {
            plateNo: vehicleInfo?.PlateNumber ?? "",
            plateCode: vehicleInfo?.PlateCode ?? "",
            plateType: "1",
            Language: "Eng"
          }
        },
        response: {
          VehicleBarcode: vehicleInfo?.VehicleBarcode,
          RegistraionType: vehicleInfo?.RegistraionType,
          RegistraionTypeDesc: vehicleInfo?.RegistraionTypeDesc,
          PlateCode: vehicleInfo?.PlateCode,
          PlateCodeArb: vehicleInfo?.PlateCodeArb,
          PlateNumber: vehicleInfo?.PlateNumber,
          ChassisNumber: vehicleInfo?.ChassisNumber,
          EngineNumber: vehicleInfo?.EngineNumber,
          Language: "Eng",
          MakeYear: vehicleInfo?.MakeYear,
          VehicleTypeID: vehicleInfo?.VehicleTypeID,
          VehicleTypeDesc: vehicleInfo?.VehicleTypeDesc,
          VehicleMakeID: vehicleInfo?.VehicleMakeID,
          VehicleMakeDesc: vehicleInfo?.VehicleMakeDesc,
          VehicleModelID: vehicleInfo?.VehicleModelID,
          VehicleModelDesc: vehicleInfo?.VehicleModelDesc,
          ColorDesc: vehicleInfo?.ColorDesc,
          RegistrationIssueDate: vehicleInfo?.RegistrationIssueDate,
          RegistrationEndDate: vehicleInfo?.RegistrationEndDate,
          InsuranceTypeID: vehicleInfo?.InsuranceTypeID,
          InsuranceTypeDesc: vehicleInfo?.InsuranceTypeDesc,
          InsuranceStartDate: vehicleInfo?.InsuranceStartDate,
          InsuranceEndDate: vehicleInfo?.InsuranceEndDate,
          InsuranecCompanyCR: vehicleInfo?.InsuranecCompanyCR,
          InsuranceCompanyName: vehicleInfo?.InsuranceCompanyName,
          errorCode: vehicleInfo?.errorCode,
          errorText: vehicleInfo?.errorText,
          StatusCode: vehicleInfo?.StatusCode,
          StatusText: vehicleInfo?.StatusText
        }
      }
    ]
  };
}
